import React from "react";
import './index.css'
import { useDispatch } from "react-redux";
import { selectJournal } from "../../../../../../redux/actions/matches";

const JournalSelector = ({labelJournals})=>{
    const dispatch = useDispatch();
    return <div className="container-journal-selector">
    <select className="container-journal-selector-button" 
    onChange={(e)=> dispatch(selectJournal(e.target.value))} 
    >
        {
           Object.keys(labelJournals)?.map(journalLabel => (
                <option value={journalLabel}>{journalLabel}</option>
            ))
        }
    </select>
</div>
}

export default JournalSelector